import { Component, OnInit, OnDestroy, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { PerfilEmpresa, PerfilCandidato } from 'src/app/interfaces/perfil';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RolesType } from 'src/app/enums/RolesType.enum';
import { UbicacionService } from 'src/app/services/ubicacion/ubicacion.service';
import { Ciudad, Estado } from 'src/app/interfaces/ubicaciones';
import { ImageType } from 'src/app/enums/imageType.enum';
import { environment } from 'src/environments/environment';
import { Empresa } from 'src/app/interfaces/empresas';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { FileType } from 'src/app/enums/fileType.enum';
import { NetworkSocialCandidateComponent } from './network-social-candidate/network-social-candidate.component';
import { ModalMessageComponent } from '../../common/modalmessage/modalmessage.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AppComponent } from 'src/app/app.component';
import { Categorias } from 'src/app/interfaces/categorias';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { Country } from 'src/app/interfaces/country';
import { Countries } from 'src/app/shared/country-data-store';
import { ConsentService } from 'src/app/services/consent/consent.service';
import { AlertService } from 'src/app/services/alert/alert.service';

const correoRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

  verArchivos: string;
  perfilEmpresa: PerfilEmpresa;
  perfilCandidato: PerfilCandidato;
  usuario: JwtResponse;
  usuarioRol: string;
  validandoPais: boolean;
  paises: Country[];
  pais: string;
  paisCodigo: number;
  estados: Estado[];
  ciudades: Ciudad[];
  categorias: Categorias[];
  estadoInicial: string;
  ciudadInicial: string;
  categoriaInicial: string;
  formPerfil: FormGroup;
  logo: File;
  archivo: File;
  avatar: File;
  esImagen: boolean;
  esPDF: boolean;
  pesoLogo: number;
  pesoPDF: number;
  excedePeso: boolean;
  excedePesoPDF: boolean;
  seleccionoEstado: boolean;
  dViajarSi: boolean;
  dViajarNo: boolean;
  visibleEmpresas: boolean;
  selecCiudad: boolean;
  selecEstado: boolean;

  // ── WhatsApp (identidad de login) ────────────────────────────────────────
  waStatus: { whatsappPhoneSet?: boolean; whatsappPhone?: string } = {};
  waEditing = false;
  waStep: 'phone' | 'otp' = 'phone';
  selectedDialCode = '521';
  waPhoneNumber = '';
  waOtpCode = '';
  waSendingOtp = false;
  waVerifyingOtp = false;
  waMsg = '';
  waMsgIsError = false;
  private waResendTimer: any;
  waResendCooldown = 0;

  readonly waCountries = [
    { dial: '521', display: '52', flag: '🇲🇽' },
    { dial: '1',   display: '1',  flag: '🇺🇸' },
    { dial: '57',  display: '57', flag: '🇨🇴' },
    { dial: '54',  display: '54', flag: '🇦🇷' },
    { dial: '56',  display: '56', flag: '🇨🇱' },
    { dial: '51',  display: '51', flag: '🇵🇪' },
    { dial: '593', display: '593', flag: '🇪🇨' },
    { dial: '58',  display: '58', flag: '🇻🇪' },
    { dial: '598', display: '598', flag: '🇺🇾' },
    { dial: '34',  display: '34', flag: '🇪🇸' },
  ];

  get waFullPhone(): string {
    const digits = this.waPhoneNumber.replace(/\D/g, '');
    return this.selectedDialCode + digits;
  }

  onWaPhoneChange(value: string): void {
    this.waPhoneNumber = (value || '').replace(/\D/g, '');
  }

  onWaOtpChange(value: string): void {
    this.waOtpCode = (value || '').replace(/\D/g, '').slice(0, 6);
  }

  @ViewChild('networkSocialCandidate') networkSocialCandidate: NetworkSocialCandidateComponent;

  constructor(private title: Title, private meta: Meta, private usuarioService: UsuarioService,
  private router: Router, private formBuilder: FormBuilder, private ubicacionService: UbicacionService,
  private modalService: NgbModal, private appComponent: AppComponent, private inicioService: InicioService,
  private consent: ConsentService, private alertService: AlertService, @Inject(PLATFORM_ID) private platformId: object) {
    this.usuario = isPlatformBrowser(this.platformId) ? JSON.parse(localStorage.getItem('currentUser')) : null;
    this.verArchivos = environment.baseArchivos;
    this.usuarioRol = (this.usuario ? this.usuario.role : null);
    this.agregarMetaData();
    this.perfilEmpresa = {} as PerfilEmpresa;
    this.perfilCandidato = {} as PerfilCandidato;
    this.seleccionoEstado = false;
    this.paises = Countries;
    this.pais = null;
    this.validandoPais = false;
    this.estadoInicial = null;
    this.ciudadInicial = null;
    this.categoriaInicial = 'Seleccione una categoria';
    this.esImagen = true;
    this.esPDF = true;
    this.excedePeso = false;
    this.pesoLogo = environment.pesoMaximoLogo;
    this.pesoPDF = environment.pesoMaximoPDF;
  }

  ngOnInit(): void {
    if(this.usuario){
      this.crearFormPerfil();
      this.obtenerPerfil(this.usuario.user.idUsuario, this.usuario.role);
      // Si el usuario aún no aceptó aviso de privacidad + términos, abrir modal.
      this.consent.syncFromServer().subscribe(active => {
        if (!active) this.consent.requestModal('perfil');
      });
      if (this.usuarioRol === 'candidato') { this.loadWaStatus(); }
    }else{
      this.router.navigate(['/acceder']);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.waResendTimer);
  }

  // ── WhatsApp (identidad de login) ────────────────────────────────────────

  loadWaStatus(): void {
    this.alertService.getEstado(this.usuario.user.idUsuario).subscribe({
      next: (res: any) => {
        const data = res?.data ?? res;
        if (data) { this.waStatus = data; }
      },
      error: () => {}
    });
  }

  openWaEditor(): void {
    this.waEditing = true;
    this.waStep = 'phone';
    this.waPhoneNumber = '';
    this.waOtpCode = '';
    this.waMsg = '';
  }

  closeWaEditor(): void {
    this.waEditing = false;
    clearInterval(this.waResendTimer);
  }

  sendWaOtp(): void {
    const digits = this.waPhoneNumber.replace(/\D/g, '');
    if (digits.length < 7) {
      this.waMsg = 'Ingresa un número válido';
      this.waMsgIsError = true;
      return;
    }
    this.waMsg = '';
    this.waSendingOtp = true;
    this.alertService.sendOtp(this.waFullPhone, this.usuario.user.idUsuario).subscribe({
      next: () => {
        this.waSendingOtp = false;
        this.waStep = 'otp';
        this.startWaResendCooldown();
      },
      error: (err) => {
        this.waSendingOtp = false;
        this.waMsg = err?.error?.message || 'Error al enviar el código';
        this.waMsgIsError = true;
      }
    });
  }

  resendWaOtp(): void {
    if (this.waResendCooldown > 0 || this.waSendingOtp) return;
    this.waOtpCode = '';
    this.sendWaOtp();
  }

  private startWaResendCooldown(): void {
    clearInterval(this.waResendTimer);
    this.waResendCooldown = 45;
    this.waResendTimer = setInterval(() => {
      this.waResendCooldown--;
      if (this.waResendCooldown <= 0) clearInterval(this.waResendTimer);
    }, 1000);
  }

  verifyWaOtp(): void {
    const code = this.waOtpCode.trim();
    if (code.length < 6) {
      this.waMsg = 'Ingresa el código completo de 6 dígitos';
      this.waMsgIsError = true;
      return;
    }
    this.waMsg = '';
    this.waVerifyingOtp = true;
    this.alertService.verifyOtp(this.waFullPhone, code, this.usuario.user.idUsuario).subscribe({
      next: () => {
        this.waVerifyingOtp = false;
        this.waMsg = 'WhatsApp verificado correctamente.';
        this.waMsgIsError = false;
        this.waEditing = false;
        clearInterval(this.waResendTimer);
        this.loadWaStatus();
      },
      error: (err) => {
        this.waVerifyingOtp = false;
        this.waMsg = err?.error?.message || 'Código incorrecto. Solicita uno nuevo.';
        this.waMsgIsError = true;
        this.waOtpCode = '';
      }
    });
  }

  private agregarMetaData(): void {
    this.title.setTitle('Perfil');
    this.meta.updateTag({name: "description", content: "Modifica tu perfil, aumenta la posibilidad de mayores propuestas."});
    this.meta.updateTag({name: "keywords", content: "perfil, candidato, empresa, información privada"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Perfil"});
    this.meta.updateTag({property: "og:description", content: "Modifica tu perfil, aumenta la posibilidad de mayores propuestas."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Perfil"});
    this.meta.updateTag({name: "twitter:description", content:"Modifica tu perfil, aumenta la posibilidad de mayores propuestas."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  crearFormPerfil(): void{
    if(this.usuarioRol == RolesType.EMPRESAS){
      this.formPerfil = this.formBuilder.group({
        nombreComercial: this.perfilEmpresa.nombreComercial ?? null,
        razonSocial: this.perfilEmpresa.razonSocial ?? null,
        giroEmpresarial: this.perfilEmpresa.giroEmpresarial ?? null,
        giroEspecifico: this.perfilEmpresa.giroEspecifico ?? null,
        correo: [this.perfilEmpresa.correo ?? null, [Validators.pattern(correoRegExp)]],
        telefono: [this.perfilEmpresa.telefono ?? null, [Validators.pattern(/^([0-9])*$/)]],
        pais: this.perfilEmpresa.pais ?? null,
        estado: this.perfilEmpresa.idEstado ?? null,
        ciudad: this.perfilEmpresa.idCiudad ?? null,
        direccion: this.perfilEmpresa.direccion ?? null,
        urlWeb: this.perfilEmpresa.paginaWeb ?? null
      });
    }else if(this.usuarioRol == RolesType.CANDIDATOS){
      const datePipe = new DatePipe('en-US');

      this.formPerfil = this.formBuilder.group({
        nombre: this.perfilCandidato.nombre ?? null,
        apellidos: this.perfilCandidato.apellidos ?? null,
        fechaNacimiento: [ datePipe.transform(this.perfilCandidato.fechaNacimiento ?? null, 'yyyy-MM-dd')],
        genero: [this.perfilCandidato.genero ?? null, [Validators.required]],
        dViajar: this.perfilCandidato.dViajar ?? null,
        dMudar: this.perfilCandidato.dMudar ?? null,
        salarioDeseado: [this.perfilCandidato.salarioDeseado ?? null, [Validators.pattern(/^([0-9.])*$/)]],
        correo: [this.perfilCandidato.correo ?? null, [Validators.pattern(correoRegExp)]],
        telefono: [this.perfilCandidato.telefono ?? null, [Validators.required , Validators.pattern(/^([0-9])*$/)]],
        pais: this.perfilCandidato.pais ?? null,
        estado: this.perfilCandidato.idEstado ?? null,
        categoria: this.perfilCandidato.idCategoria ?? null,
        ciudad: this.perfilCandidato.idCiudad ?? null,
        visibilidadDatos: this.perfilCandidato.visibilidadDatos ?? false
      });
      this.visibleEmpresas = this.perfilCandidato.visibilidadDatos ?? false;
    }else{
      this.formPerfil = this.formBuilder.group({});
      this.router.navigate(['/acceder']);
      this.abrirModalMessage("Error", "No se encontró los datos del usuario.");
    }
  }

  async obtenerPerfil(idUsuario: number, rol: string): Promise<any> {
    try {
      const response = await this.usuarioService.obtenerPerfilEmpresaOCandidato(idUsuario, rol);
      if(response.data){
        if (this.usuarioRol == RolesType.EMPRESAS) {
          this.perfilEmpresa = response.data;
          if(this.perfilEmpresa){
            this.actualiarImgMenu(this.perfilEmpresa.logo);
            this.perfilEmpresa.logo = this.resolveAvatarUrl(this.perfilEmpresa.logo, environment.empresaDefault);
          }
        } else {
          this.perfilCandidato = response.data;
          if(this.perfilCandidato){
            this.actualiarImgMenu(this.perfilCandidato.avatar);
            this.perfilCandidato.avatar = this.resolveAvatarUrl(this.perfilCandidato.avatar, environment.candidatoDefault);
            this.networkSocialCandidate.cargarRedesSocialesCandidato(this.perfilCandidato);
          }
          this.categorias = await this.obtenerCategorias();
          if(response.data.idCategoria){
            this.categoriaInicial = this.categorias.find(categoria => categoria.idCategoria == response.data.idCategoria).nombreCategoria;
          }

          // if(response.data.fechaNacimiento == null &&
          //   response.data.telefono == null &&
          //   response.data.genero == null ){
  
          //   console.log("Perfil Destacado Nuevo")
          //   window.addEventListener('beforeunload', (event) => {
          //     event.preventDefault();
          //     event.returnValue = '';
          //   });
          // }
        }
        this.paisCodigo = response.data.claveTelefono;
        this.pais = response.data.pais;
        this.estados = await this.cargarEstados();

        if(response.data.idEstado > 0){
          this.estadoInicial = this.estados.find(estado => estado.id == response.data.idEstado).nombre;
          this.ciudades = await this.cargarCiudades(response.data.idEstado);
        }

        if(response.data.idCiudad > 0) {
          this.ciudadInicial = this.ciudades.find(ciudad => ciudad.claveCiudad == response.data.idCiudad).nombre;
        }

        this.crearFormPerfil();
      }
    } catch (error) {
      console.error("Error en cargar el Perfil", error);
    }
  }

  async cargarEstados(): Promise<any> {
    try {
      const response = await this.ubicacionService.obtenerEstados();
      return response.data;
    } catch (error) {
      console.error("Error al cargar el combo estados", error);
    }
  }

  async obtenerCategorias(){
    try {
      const response = await this.inicioService.obtenerCategoriasEmpresas();
      return response.data;
    } catch (error) {
      console.error("Error al obtener las categorías", error);
    }
  }

  seleccionarPais(pais: string): void {
    this.pais = pais;
    if(this.pais != "México"){
        this.formPerfil.get("estado").setValue(0);
        this.formPerfil.get("ciudad").setValue(0);
        this.estadoInicial = null;
        this.ciudadInicial = null;
    }
  }

  async seleccionarEstado(){
    if(this.formPerfil.value.estado){
      this.seleccionoEstado = true;
      this.formPerfil.get("ciudad").setValue(0);
      this.ciudadInicial = null;

      this.ciudades = await this.cargarCiudades(this.formPerfil.value.estado);
      setTimeout(() => {
        this.seleccionoEstado = false;
      }, 2000);
    }
  }

  async cargarCiudades(idEstado: number): Promise<any> {
    try {
      const response = await this.ubicacionService.obtenerCiudadesPorEstado(idEstado);
      return response.data;
    } catch (error) {
      console.error("Error al cargar el combo ciudades.", error);
    }
  }

  subirLogo(e:any): void{
    this.logo = e.target.files[0];
    if(this.logo.type == ImageType.JPEG || this.logo.type == ImageType.PNG
    || this.logo.type == ImageType.ICO || this.logo.type == ImageType.TIF){
      this.esImagen = true;
      if(this.logo.size <= this.pesoLogo){
        this.excedePeso = false;

        const formData = new FormData();
        formData.append('logo', this.logo);
        this.usuarioService.actualizarLogoEmpresa(this.usuario.user.idUsuario, formData).pipe(
          catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })).subscribe(result => {
          if(result.success){
            this.abrirModalMessage("Éxito", "Se han actualizado su logo con el nombre: <strong>"+this.logo.name+"</strong>");
            this.reiniciarArchivos();
            this.ngOnInit();
          }else{
            this.abrirModalMessage("Error", "Se ha producido un error al actualizar su logo.");
            console.error('Error al actualizar su logo: ', result.messageError);
          }
        });
      }else{
        this.excedePeso = true;
      }
    }else{
      this.esImagen = false;
    }
  }

  subirImagen(e:any): void{
    this.avatar = e.target.files[0];
    if(this.avatar.type == ImageType.JPEG || this.avatar.type == ImageType.PNG
    || this.avatar.type == ImageType.ICO || this.avatar.type == ImageType.TIF){
      this.esImagen = true;
      if(this.avatar.size <= this.pesoLogo){
        this.excedePeso = false;

        const formData = new FormData();
        formData.append('avatar', this.avatar);
        this.usuarioService.actualizarAvatarCandidato(this.usuario.user.idUsuario, formData).pipe(
          catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })).subscribe(result => {
          if(result.success){
            this.abrirModalMessage("Éxito", "Se ha actualizado su foto con el nombre: <strong>"+this.avatar.name+"</strong>");
            this.reiniciarArchivos();
            this.ngOnInit();
          }else{
            this.abrirModalMessage("Error", "Se ha producido un error al actualizar su foto.");
            console.error('Error al actualizar su foto: ', result.messageError);
          }
        });
      }else{
        this.excedePeso = true;
      }
    }else{
      this.esImagen = false;
    }
  }

  actualiarImgMenu(urlImagen: string): void {
    this.usuario.user.img = urlImagen;
    localStorage.setItem('currentUser', JSON.stringify(this.usuario));
    if(this.usuarioRol === RolesType.CANDIDATOS){
      this.appComponent.actualizarMenuBar();
    }
  }

  subirPDF(e:any): void{
    this.archivo = e.target.files[0];
    if(this.archivo.type == FileType.PDF){
      this.esPDF = true;
      if(this.archivo.size <= this.pesoPDF){
        this.excedePesoPDF = false;

        const formData = new FormData();
        formData.append('cv', this.archivo);
        this.usuarioService.actualizarCvCandidato(this.usuario.user.idUsuario, formData).pipe(
          catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })).subscribe(result => {
          if(result.success){
            this.abrirModalMessage("Éxito", "Se han actualizado su CV correctamente con el nombre: <strong>"+this.archivo.name+"</strong>");
            this.reiniciarArchivos();
            this.ngOnInit();
          }else{
            this.abrirModalMessage("Error", "Se ha producido un error al actualizar su CV.");
            console.error('Error al actualizar su CV: ', result.messageError);
          }
        });
      }else{
        this.excedePesoPDF = true;
      }
    }else{
      this.esPDF = false;
    }
  }

  obtenerCodigoPais(event: any): void{
    this.paisCodigo = event;
  }

  validarDatosPerfil(): void{
    if(this.usuarioRol === RolesType.EMPRESAS){
      this.actualizarEmpresa();
    }else if(this.usuarioRol === RolesType.CANDIDATOS){
      this.actualizarCandidato();
    }else{
      return;
    }
  }

  actualizarEmpresa(): void{
    if(this.verificarCambioEstado()){
        const empresa: Empresa = {
            idUsuario: this.perfilEmpresa.idUsuario,
            correo: this.formPerfil.get('correo').value || this.perfilEmpresa.correo,
            nombreComercial: this.formPerfil.get('nombreComercial').value || this.perfilEmpresa.nombreComercial,
            razonSocial: this.formPerfil.get('razonSocial').value || this.perfilEmpresa.razonSocial,
            direccion: this.formPerfil.get('direccion').value || this.perfilEmpresa.direccion,
            giroEmpresarial: this.formPerfil.get('giroEmpresarial').value || this.perfilEmpresa.giroEmpresarial,
            giroEspecifico: this.formPerfil.get('giroEspecifico').value || this.perfilEmpresa.giroEspecifico,
            logo: this.perfilEmpresa.logo.substring(this.perfilEmpresa.logo != environment.empresaDefault ?
                environment.baseArchivos.length : 0),
            paginaWeb: this.formPerfil.get('urlWeb').value || this.perfilEmpresa.paginaWeb,
            pais: this.pais || this.perfilEmpresa.pais,
            telefono: this.formPerfil.get('telefono').value || this.perfilEmpresa.telefono,
            idEstado: this.formPerfil.get('estado').value || this.perfilEmpresa.idEstado,
            idCiudad: (this.formPerfil.get('ciudad').value || this.perfilEmpresa.idCiudad)
          };
          const formData = new FormData();
          const blob = new Blob([JSON.stringify(empresa)], { type: "application/json" });
          formData.append('empresa', blob);

          this.usuarioService.actualizarPerfilEmpresa(formData).pipe(
            catchError(error => {
            let mensajeError = '';
            if (error.status === 0) {
              mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
              mensajeError += `Http error: ${error.message}`;
              console.error('se ha producido un error:', error.error);
            } else {
              mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
              mensajeError += `Http error: ${error.message}`;
              console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
            }
            this.abrirModalMessage("Error", mensajeError);
            return throwError(mensajeError);
          })).subscribe(result => {
            if(result.success){
              this.archivo = undefined as File;
              this.abrirModalMessage("Éxito", "Se han actualizado sus datos de la Empresa.");
              this.ngOnInit();
            }else{
              this.abrirModalMessage("Error", "Se ha producido un error al actualizar sus datos.");
              console.error('Error al crear actualizar datos para empresa: ', result.messageError);
            }
          });
    }
  }

  actualizarCandidato(): void {
    console.log("Pass")
    if(this.verificarCambioEstado()){
        const candidato: any = {
            id: this.usuario.user.idUsuario,
            correo: this.formPerfil.get('correo').value || this.perfilCandidato.correo,
            nombre: this.formPerfil.get('nombre').value || this.perfilCandidato.nombre,
            apellidos: this.formPerfil.get('apellidos').value || this.perfilCandidato.apellidos,
            genero: this.formPerfil.get('genero').value || this.perfilCandidato.genero,
            pais: this.pais || this.perfilCandidato.pais,
            idEstado: this.formPerfil.get('estado').value  || this.perfilCandidato.idEstado,
            idCiudad: this.formPerfil.get('ciudad').value || this.perfilCandidato.idCiudad,
            idCategoria: this.formPerfil.get('categoria').value || this.perfilCandidato.idCategoria,
            salarioDeseado: this.formPerfil.get('salarioDeseado').value  || this.perfilCandidato.salarioDeseado,
            claveTelefono: this.paisCodigo || this.perfilCandidato.claveTelefono,
            telefono: this.formPerfil.get('telefono').value || this.perfilCandidato.telefono,
            dviajar: this.formPerfil.get('dViajar').value || this.perfilCandidato.dViajar,
            dmudar: this.formPerfil.get('dMudar').value || this.perfilCandidato.dMudar,
            fechaNacimiento: this.formPerfil.get('fechaNacimiento').value || this.perfilCandidato.fechaNacimiento,
            visibilidadDatos:this.visibleEmpresas
          };
          this.usuarioService.actualizarPerfilCandidato(JSON.stringify(candidato)).pipe(
            catchError(error => {
              let mensajeError = '';
              if (error.status === 0) {
                mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
                mensajeError += `Http error: ${error.message}`;
                console.error('se ha producido un error:', error.error);
              } else {
                mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
                mensajeError += `Http error: ${error.message}`;
                console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
              }
              this.abrirModalMessage("Error", mensajeError);
              return throwError(mensajeError);
            })
          ).subscribe(result => {
            if (result.success) {
              this.ngOnInit();
              this.abrirModalMessage("Éxito", "Se ha actulizado correctamente.");
            } else {
              this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
              console.error('Error al actualizar el perfil del candidato: ', result.messageError);
            }
          });
    }
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  /**
   * Construye la URL del avatar/logo de manera robusta:
   * - null/empty/'null' string → fallback default
   * - URL absoluta (http/https) → tal cual
   * - path /assets/... → tal cual (default ya viene como path absoluto)
   * - cualquier otro path relativo → baseArchivos + path
   */
  private resolveAvatarUrl(value: any, defaultUrl: string): string {
    if (!value || value === 'null' || value === 'undefined') return defaultUrl;
    const v = String(value).trim();
    if (!v || v === defaultUrl) return defaultUrl;
    if (v.startsWith('http://') || v.startsWith('https://')) {
      // Cache busting para URLs absolutas (CDN puede cachear)
      const sep = v.includes('?') ? '&' : '?';
      return v + sep + 'v=' + Date.now();
    }
    if (v.startsWith('/assets/')) return v;
    // Ruta relativa (ej. /avatar/94560-logo.png) → prefijar con baseArchivos
    // Quitar el / inicial para no generar doble slash con baseArchivos
    const relative = v.startsWith('/') ? v.substring(1) : v;
    // Cache busting al final para forzar recarga tras upload
    return this.verArchivos + relative + '?v=' + Date.now();
  }

  editarVisibilidadCandidato(){
    if(this.perfilCandidato.visibilidadDatos){
        this.visibleEmpresas = false;
    }else{
        this.visibleEmpresas = true;
    }
  }

  reiniciarArchivos(): void {
    this.logo = null as File;
    this.archivo = null as File;
    this.avatar = null as File;
  }

  verificarCambioEstado():boolean{
    if(this.formPerfil.value.estado == 0 && this.formPerfil.value.ciudad == 0
        && this.pais != 'México'){
        return true;
    }
    if(this.formPerfil.value.estado != 0 && this.formPerfil.value.ciudad != 0
        && this.pais == 'México'){
        return true;
    }

    if(this.formPerfil.value.ciudad == 0){ this.selecCiudad = true; }

    if(this.formPerfil.value.estado == 0){ this.selecEstado = true; }

    setTimeout(() => {
        this.selecCiudad = false;
        this.selecEstado = false;
    }, 2000);
      return false;
  }
}
